export default __webpack_public_path__ + "i18n/translations/translation-cs.c2061244.json";